import { Directive, Input, computed, signal } from '@angular/core';

@Directive({ standalone: true })
export class OddsCardResult {
    private _event = signal<any>(null);

    @Input() set event(value: any) {
        this._event.set(value);
    }
    get event() {
        return this._event();
    }

    parsedGoalScorersTeamA = computed(() => (this.event?.teamA?.goalScorers ? this.event.teamA.goalScorers.split(/, (?=[A-Za-z])/) : []));

    parsedGoalScorersTeamB = computed(() => (this.event?.teamB?.goalScorers ? this.event.teamB.goalScorers.split(/, (?=[A-Za-z])/) : []));
}
